// Locale-to-currency mapping for the DACH + Benelux + PL market
const localeCurrencyMap: Record<string, { currency: string; locale: string }> = {
  de: { currency: "EUR", locale: "de-DE" },
  en: { currency: "EUR", locale: "en-GB" },
  nl: { currency: "EUR", locale: "nl-NL" },
  "nl-BE": { currency: "EUR", locale: "nl-BE" },
  fr: { currency: "EUR", locale: "fr-FR" },
  wa: { currency: "EUR", locale: "fr-BE" },
  pl: { currency: "PLN", locale: "pl-PL" },
  "de-CH": { currency: "CHF", locale: "de-CH" },
};

// EUR→target exchange rates (approximate, update as needed)
const exchangeRates: Record<string, number> = {
  EUR: 1,
  CHF: 0.96,
  PLN: 4.28,
};

export function formatPrice(cents: number, lang: string, options?: { decimals?: boolean }): string {
  const config = localeCurrencyMap[lang] || localeCurrencyMap.de;
  const rate = exchangeRates[config.currency] || 1;
  const amount = (cents / 100) * rate;

  return new Intl.NumberFormat(config.locale, {
    style: "currency",
    currency: config.currency,
    minimumFractionDigits: options?.decimals ? 2 : 0,
    maximumFractionDigits: options?.decimals ? 2 : 0,
  }).format(amount);
}

export function getCurrencySymbol(lang: string): string {
  const config = localeCurrencyMap[lang] || localeCurrencyMap.de;
  return config.currency === "CHF" ? "CHF" : config.currency === "PLN" ? "zł" : "€";
}
